import React from 'react';
import {
  Card,
  CardBody,
  CardHeader,
} from "../components";

function Kebijakan() {
  return (
    <>
      <div className="page-heading">
        <h3>Kebijakan Mutu</h3>
        <p className="text-subtitle text-muted">Universitas Muhammadiyah Makassar</p>
      </div>
      
      <div className="page-content">
        <section className="row">
          <div className="col-12">
            <Card>
              <CardHeader title="Kebijakan Mutu Universitas" />
              <CardBody>
                <p className="text-justify mb-3">
                  Universitas Muhammadiyah Makassar berkomitmen untuk menyelenggarakan pendidikan tinggi yang 
                  berkualitas, berintegritas, dan berdaya saing global melalui implementasi sistem penjaminan 
                  mutu yang konsisten dan berkelanjutan.
                </p>
                <p className="text-justify mb-0">
                  Kebijakan mutu ini menjadi pedoman bagi seluruh civitas akademika dalam melaksanakan Tri Dharma 
                  Perguruan Tinggi dengan standar mutu yang tinggi dan akuntabel.
                </p>
              </CardBody>
            </Card>
          </div>
        </section>

        <section className="row">
          <div className="col-12">
            <Card>
              <CardHeader title="Standar Nasional Pendidikan Tinggi (SN-DIKTI)" />
              <CardBody>
                <p className="mb-3">
                  Universitas Muhammadiyah Makassar menerapkan 8 Standar Nasional Pendidikan Tinggi sebagai 
                  acuan dalam penjaminan mutu:
                </p>
                <div className="row">
                  <div className="col-12 col-md-6">
                    <ol>
                      <li className="mb-2"><strong>Standar Kompetensi Lulusan</strong> - Kriteria minimal tentang kualifikasi kemampuan lulusan</li>
                      <li className="mb-2"><strong>Standar Isi Pembelajaran</strong> - Kriteria minimal tentang kedalaman dan keluasan materi</li>
                      <li className="mb-2"><strong>Standar Proses Pembelajaran</strong> - Kriteria minimal tentang pelaksanaan pembelajaran</li>
                      <li className="mb-0"><strong>Standar Penilaian</strong> - Kriteria minimal tentang penilaian proses dan hasil belajar</li>
                    </ol>
                  </div>
                  <div className="col-12 col-md-6">
                    <ol start="5">
                      <li className="mb-2"><strong>Standar Dosen dan Tenaga Kependidikan</strong> - Kriteria minimal tentang kualifikasi SDM</li>
                      <li className="mb-2"><strong>Standar Sarana dan Prasarana</strong> - Kriteria minimal tentang fasilitas pembelajaran</li>
                      <li className="mb-2"><strong>Standar Pengelolaan</strong> - Kriteria minimal tentang tata kelola perguruan tinggi</li>
                      <li className="mb-0"><strong>Standar Pembiayaan</strong> - Kriteria minimal tentang komponen dan besaran biaya</li>
                    </ol>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
        </section>

        <section className="row">
          <div className="col-12">
            <Card>
              <CardHeader title="Siklus Penjaminan Mutu (PPEPP)" />
              <CardBody>
                <p className="mb-3">
                  Sistem penjaminan mutu internal dilaksanakan melalui siklus PPEPP (Plan-Do-Check-Act):
                </p>
                <div className="row">
                  <div className="col-12 col-md-6 col-lg-3 mb-3">
                    <div className="p-3 bg-light rounded">
                      <h6 className="text-primary mb-2"><i className="bi bi-clipboard-check me-2"></i>PENETAPAN</h6>
                      <p className="small mb-0">Menetapkan standar mutu dan dokumen penjaminan mutu</p>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-3 mb-3">
                    <div className="p-3 bg-light rounded">
                      <h6 className="text-primary mb-2"><i className="bi bi-gear me-2"></i>PELAKSANAAN</h6>
                      <p className="small mb-0">Melaksanakan standar mutu yang telah ditetapkan</p>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-3 mb-3">
                    <div className="p-3 bg-light rounded">
                      <h6 className="text-primary mb-2"><i className="bi bi-bar-chart me-2"></i>EVALUASI</h6>
                      <p className="small mb-0">Monitoring dan evaluasi ketercapaian standar</p>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-3 mb-3">
                    <div className="p-3 bg-light rounded">
                      <h6 className="text-primary mb-2"><i className="bi bi-arrow-clockwise me-2"></i>PENGENDALIAN</h6>
                      <p className="small mb-0">Perbaikan berkelanjutan berdasarkan hasil evaluasi</p>
                    </div>
                  </div>
                  <div className="col-12 col-lg-3">
                    <div className="p-3 bg-light rounded">
                      <h6 className="text-primary mb-2"><i className="bi bi-trophy me-2"></i>PENINGKATAN</h6>
                      <p className="small mb-0">Peningkatan mutu secara berkelanjutan</p>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
        </section>

        <section className="row">
          <div className="col-12">
            <Card>
              <CardHeader title="Komitmen Mutu" />
              <CardBody>
                <h6 className="mb-3 fw-bold">Universitas Muhammadiyah Makassar berkomitmen untuk:</h6>
                <div className="row">
                  <div className="col-12 col-md-6">
                    <ul>
                      <li className="mb-2">Memastikan seluruh proses pendidikan memenuhi standar mutu</li>
                      <li className="mb-2">Melakukan perbaikan berkelanjutan dalam semua aspek pengelolaan</li>
                      <li className="mb-2">Melibatkan seluruh civitas akademika dalam penjaminan mutu</li>
                    </ul>
                  </div>
                  <div className="col-12 col-md-6">
                    <ul>
                      <li className="mb-2">Mengembangkan budaya mutu di lingkungan universitas</li>
                      <li className="mb-2">Meningkatkan kepuasan stakeholder secara konsisten</li>
                      <li className="mb-0">Mematuhi peraturan dan perundang-undangan yang berlaku</li>
                    </ul>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
        </section>
      </div>
    </>
  );
}

export default Kebijakan;
